module.exports = __webpack_public_path__ + "img/cklogo.d41c9f4a.png";